import { SET_ADDDRIVER } from '../actions';

const driveradd = (state = [], action) => {
  switch (action.type) {
	case SET_ADDDRIVER:
      return [...action.value];  
    default: return state;
  }
}

export default driveradd;
